import { useState } from 'react';
import { IClientTripSearchBackFull, IClientTripBrief } from '@bustickus/models-client';
import { dateFormat } from 'common/helpers';
import { Box, Flex } from 'components';
import { BackTripsBlock, DateBlock, TicketDataBlock, TravelTimeBlock } from './components';
import './style.scss';

interface IProps {
  trip: IClientTripBrief;
  back: IClientTripSearchBackFull | null | undefined;
  dCityId: string | null | undefined;
  aCityId: string | null | undefined;
}

function TripCard(props: IProps) {
  const [backTrip, setBackTrip] = useState<IClientTripBrief | null>(
    props.back != null && props.back.trips.length > 0 ? props.back.trips[0] : null
  );

  const dDateFormated = dateFormat(props.trip.departure?.departureDate);
  const aDateFormated = dateFormat(props.trip.arrival?.arrivalDate);

  return (
    <Box>
      <Flex direction='column'>
        <Flex
          direction='column'
          gap={10}
          className='trip-main-cntr-Lakj3'
        >
          <Flex justifyContent='space-between'>
            <Flex direction='column'>
              <DateBlock
                date={props.trip.departure?.departureDate}
                isRightAlign={false}
              />
              <Flex
                direction='column'
                className='trip-data-WS7B'
              >
                <div>{props.trip.departure?.cityName ?? 'N/A'}</div>
                <div className='trip-address-Ma3Jads'>{dDateFormated.mskTimezone}</div>
                <div className='trip-address-Ma3Jads'>{props.trip.departure?.address}</div>
              </Flex>
            </Flex>

            <TravelTimeBlock travelTimeSeconds={props.trip.travelTimeSeconds} />

            <Flex
              direction='column'
              className='date-arrival-block-uAj1a'
              gap={0}
            >
              <DateBlock
                date={props.trip.arrival?.arrivalDate}
                isRightAlign={true}
              />
              <Flex
                direction='column'
                alignItems='flex-end'
                className='trip-data-WS7B'
              >
                <div>{props.trip.arrival?.cityName ?? 'N/A'}</div>
                <div className='trip-address-Ma3Jads'>{aDateFormated.mskTimezone}</div>
                <div className='trip-address-Ma3Jads'>{props.trip.arrival?.address ?? ''}</div>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>

      {props.back != null && (
        <BackTripsBlock
          departureCityName={props.trip.departure?.cityName}
          arrivalCityName={props.trip.arrival?.cityName}
          back={props.back}
          onChange={setBackTrip}
          value={backTrip}
        />
      )}

      <TicketDataBlock
        aCityId={props.aCityId}
        dCityId={props.dCityId}
        trip={props.trip}
        backTrip={backTrip}
      />
    </Box>
  );
}

export default TripCard;
